import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { InvestigationService } from 'src/app/service/investigation.service';

@Component({
    selector: 'app-period-dropdown',
    templateUrl: './period-dropdown.component.html',
    styleUrls: ['./period-dropdown.component.scss'],
    standalone: false
})
export class PeriodDropdownComponent implements OnInit {

  @Input()
  periodLabel: string = ""
  @Input()
  module: string = ""
  @Output()
  eventHandler = new EventEmitter();
  periodData = []
  selected_period_id
  selected_period_value
  plnng_period = 'Planning Period'
  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly constants: Constants, private readonly periodsService: InvestigationService) { }

  ngOnInit(): void {
    this.checkPeriodsList()

  }

  checkPeriodsList() {
    if (this.periodLabel == this.plnng_period) { // NOSONAR
      this.getPeriodList();
    } else {
      const tempPeriod = JSON.parse(localStorage.getItem("period_data"))
      if (tempPeriod && tempPeriod.length > 0) {
        this.periodData = tempPeriod
        if (this.periodData.length > 0) {
          this.selected_period_id = this.periodData[0].periodId;
          const tempSelectedPeriodId = localStorage.getItem("selectedPeriodId");
          if (tempSelectedPeriodId) {
            this.selected_period_id = tempSelectedPeriodId
          }

        }
        this.onPeriodChange();
      } else
      {
        this.getPeriodList();
      }
    }
  }

  getPeriodList() {
    this.periodsService.getPeriodsList().subscribe(
      response => {
        if (response.length > 0) {
          this.periodData = response
          if (this.periodData.length > 0) {
            this.selected_period_id = this.periodData[0].periodId;
          }

          localStorage.setItem("period_data", JSON.stringify(this.periodData))
          if (this.periodLabel == this.plnng_period) { // NOSONAR
            const tempSelectedPeriodId = JSON.parse(localStorage.getItem("selectedPeriodId"))
            if (tempSelectedPeriodId && !isNaN(tempSelectedPeriodId)) {
              const tempSelectedPeriodIdIsPresent = this.periodData.findIndex(x => x.periodId == tempSelectedPeriodId) // NOSONAR
              this.selected_period_id = this.periodData[tempSelectedPeriodIdIsPresent > 0 ? tempSelectedPeriodIdIsPresent : 0].periodId;
            }
          }

          this.onPeriodChange();

        }
      }, error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.localEventHandler({ eventType: "NOTIFICATION_ERROR", eventMessage: this.constants.APIErrorMessage });

      }
    );
  }

  onPeriodChange() {
    this.selected_period_value = this.periodData.find(x => x.periodId == this.selected_period_id).period // NOSONAR
    if (this.periodLabel == this.plnng_period) { // NOSONAR
      localStorage.setItem("selectedPeriodId", this.selected_period_id);
      localStorage.setItem("selectedPeriodValue", this.selected_period_value);
    }

    this.localEventHandler({
      eventType: "CHANGE_PERIOD",
      periodId: Number(this.selected_period_id),
      periodValue: this.selected_period_value,
      module: this.module
    })
  }

  localEventHandler(data) {
    this.eventHandler.emit(data);
  }

}
